

















































































































































































































































































































































































































// Vue
import { defineComponent, ref, Ref, onMounted, computed } from '@vue/composition-api'

// componnents
import { PageHeader, Logo, ButtonExport } from '@/components'
import { Input } from '@/components/general'
import { DataTable } from '@/components/table'
import ModalRefreshment from './ModalRefreshment.vue'

// models
import { IBreadcrumb } from '@/models'
import { AdvanceType, BondType, DiscountTypeModel, ReasonForPermissionModel } from '@/models/config'
import { BiweeklyPayroll, PayrollGenerated, PayrollInput } from '@/models/payroll/PayrollTypes'
import { DiscountControl } from '@/models/dailyControl'

// services
import PayrollService from '@/services/payroll/PayrollService'
import { ReasonForPermissionService, AdvanceTypesService, BondTypesService, DiscountTypesService } from '@/services/config'
// utils
import { dateLibs, alerts, formatAmount } from '@/utils'
import { getTextTypeOfContract, getTextWorkType, TYPE_REGIME_AFP, TYPE_REGIME_ONP, TYPE_REGIME_NOT_APPLY, WORK_TYPE_LABORER } from '@/constants'

// constants
import { TYPE_PERCENTAGE, TYPE_AMOUNT, DISCOUNT_TYPE_RENT_5TH } from '@/constants/discountTypeConstants'
import { REASON_WITH_PAID } from '@/constants/reasonForPermissionContants'
import { getFullNameOnlyFormat } from '@/utils/employee'

export default defineComponent({
  name: 'PayrollView',
  components: {
    PageHeader,
    Logo,
    DataTable,
    Input,
    ButtonExport,
    ModalRefreshment
  },
  setup (props, { root: { $route, $router } }) {
    const route = $route
    const router = $router
    const loading = ref(false)
    const rangeYears = dateLibs.createRangeYears()
    const { year, month, fortnight, work_category } = route.query
    const validParams = () => {
      if (!Number.isInteger(Number(year)) || !Number.isInteger(Number(month)) || !Number.isInteger(Number(fortnight))) {
        return false
      }
      if (!rangeYears.find(range => Number(range.value) === Number(year))) {
        return false
      }
      if (Number(month) <= 0 || Number(month) > 12) {
        return false
      }
      if (Number(fortnight) <= 0 || Number(fortnight) >= 3) {
        return false
      }
      return true
    }
    if (!validParams()) {
      alerts.error('Los datos enviados son inválidos')
      router.push({
        name: 'work-sheets'
      })
    }
    const breadcrumbs: IBreadcrumb[] = [
      {
        text: 'Dashboard',
        active: false,
        to: {
          name: 'home'
        }
      },
      {
        text: 'P. Quincenal',
        active: false,
        to: { name: 'work-sheets' }
      },
      {
        text: 'Planilla',
        active: true
      }
    ]
    const title = 'Planilla'
    const filter = ref('')
    const actionForm: Ref<'save'|'update'> = ref('save')
    const idPayrollEdit: Ref<number|null> = ref(null)
    const monthSelected = computed(() => dateLibs.getAllMonths().find(m => Number(m.value) === Number(month)))
    const fSelected = computed(() => dateLibs.fortnightsDefault.find(f => Number(f.value) === Number(fortnight)))
    const description = computed(() => `${monthSelected.value?.text} (${fSelected.value?.text}) - ${year}`)
    const allReasonPermission: Ref<ReasonForPermissionModel[]> = ref([])
    const allAdvanceTypes: Ref<AdvanceType[]> = ref([])
    const allBondTypes: Ref<BondType[]> = ref([])
    const allDiscountTypes: Ref<DiscountTypeModel[]> = ref([])
    const oldPayrollData: Ref<PayrollGenerated[]> = ref([])
    const showRefreshmentModal = ref(false)
    const refreshmentEmployeeId: Ref<number|string|null> = ref(null)
    const refreshmentEmployeeName = ref('')
    const refreshmentItem: Ref<PayrollGenerated|null> = ref(null)
    const payrollYear = Number(year)
    const payrollMonth = Number(month)
    const payrollFortnight = Number(fortnight)

    const openRefreshmentModal = (item: PayrollGenerated) => {
      refreshmentItem.value = item
      refreshmentEmployeeId.value = item.employee.id
      refreshmentEmployeeName.value = getFullNameOnlyFormat(item.employee as any)
      showRefreshmentModal.value = true
    }

    const closeRefreshmentModal = () => {
      showRefreshmentModal.value = false
    }

    const getAllParameters = async () => {
      loading.value = true
      const reasons = await ReasonForPermissionService.getActivated()
      allReasonPermission.value = reasons.filter(reason => reason.type === REASON_WITH_PAID)
      allAdvanceTypes.value = await AdvanceTypesService.getActivated()
      allBondTypes.value = await BondTypesService.getActivated()
      allDiscountTypes.value = await DiscountTypesService.getActivated()
      loading.value = false
    }

    const headers_main = [
      {
        key: 'index',
        sortable: false,
        label: 'Nº',
        class: 'one-line bg-payroll'
      },
      {
        key: 'employee.assignment.work_type',
        sortable: false,
        label: 'T TRAB',
        class: 'one-line bg-payroll'
      },
      {
        key: 'type_regime',
        sortable: false,
        label: 'AFP/ONP',
        class: 'one-line bg-payroll'
      },
      {
        key: 'employee.fullLastName',
        sortable: true,
        label: 'EMPLEADO',
        class: 'one-line bg-payroll',
        stickyColumn: true
      },
      {
        key: 'base_salary',
        sortable: true,
        label: 'SUELDO',
        class: 'one-line bg-payroll',
        formatter: (value: number) => {
          return formatAmount(value)
        }
      },
      {
        key: 'employee.finance.family_allowance',
        sortable: true,
        label: 'ASIG FAM',
        class: 'one-line bg-payroll',
        formatter: (value: number) => {
          return formatAmount(value)
        }
      },
      {
        key: 'salary_total',
        sortable: true,
        label: 'SUELDO T',
        class: 'one-line bg-payroll',
        formatter: (value: number) => {
          return formatAmount(value)
        }
      },
      {
        key: 'month_days',
        sortable: true,
        label: 'MES',
        class: 'one-line bg-payroll'
      },
      {
        key: 'afp_total',
        sortable: true,
        label: 'AFP/ONP',
        class: 'one-line bg-payroll'
      },
      {
        key: 'payed_days',
        sortable: true,
        label: 'JORNAL',
        class: 'one-line bg-payroll'
      },
      {
        key: 'days_piecework_fortnight',
        sortable: true,
        label: 'DESTAJO',
        class: 'one-line bg-payroll'
      },
      {
        key: 'holidays',
        sortable: true,
        label: 'DÍAS FERIADOS',
        class: 'one-line bg-payroll'
      },
      {
        key: 'payed_days_total',
        sortable: true,
        label: 'PAGADOS',
        class: 'one-line bg-payroll'
      },
      {
        key: 'ajenos',
        sortable: true,
        label: 'MOTIVOS AJENOS',
        class: 'one-line bg-payroll'
      },
      {
        key: 'basic_fortnight',
        sortable: true,
        label: 'QUINCENA BÁSICO',
        class: 'one-line bg-payroll',
        formatter: (value: number) => {
          return formatAmount(value)
        }
      },
      {
        key: 'basic_piecework_fortnight',
        sortable: true,
        label: 'QUINCENA DESTAJO',
        class: 'one-line bg-payroll',
        formatter: (value: number) => {
          return formatAmount(value)
        }
      },
      {
        key: 'total_amount_hours_normal',
        sortable: false,
        label: 'HN',
        class: 'one-line bg-payroll',
        formatter: (value: number) => {
          return formatAmount(value)
        }
      },
      {
        key: 'total_amount_hours_extra_25',
        sortable: false,
        label: 'HE 25%',
        class: 'one-line bg-payroll'
      },
      {
        key: 'total_amount_hours_extra_35',
        sortable: false,
        label: 'HE 35%',
        class: 'one-line bg-payroll'
      },
      {
        key: 'holiday_factor',
        sortable: false,
        label: 'HE DOBLES',
        class: 'one-line bg-payroll'
      },
      {
        key: 'total_fortnight',
        sortable: true,
        label: 'QUINCENA TOTAL',
        class: 'one-line bg-payroll',
        formatter: (value: number) => {
          return formatAmount(value)
        }
      },
      {
        key: 'householdAllowance15',
        label: 'ASIG. FAM (15NAL)',
        sortable: false,
        class: 'one-line bg-payroll'
      },
      {
        key: 'total_extra_25',
        sortable: true,
        label: 'Horas Extras 25%',
        class: 'one-line bg-payroll',
        formatter: (value: number) => {
          return formatAmount(value)
        }
      },
      {
        key: 'total_extra_35',
        sortable: true,
        label: 'Horas Extras 35%',
        class: 'one-line bg-payroll',
        formatter: (value: number) => {
          return formatAmount(value)
        }
      },
      {
        key: 'total_extra_double',
        sortable: true,
        label: 'HE Dobles',
        class: 'one-line bg-payroll'
      },
      {
        key: 'snackDays',
        sortable: false,
        label: 'DÍAS REFRI',
        class: 'one-line bg-payroll'
      },
      {
        key: 'refreshment',
        sortable: false,
        label: 'REFRIGERIO',
        class: 'one-line bg-payroll'
      },
      {
        key: 'holidays_amount',
        sortable: false,
        label: 'FERIADOS',
        class: 'one-line bg-payroll',
        formatter: (value: number) => {
          return formatAmount(value)
        }
      },
      {
        key: 'loan_total',
        sortable: false,
        label: 'PRESTAMOS',
        class: 'one-line bg-payroll',
        formatter: (value: number) => {
          return formatAmount(value)
        }
      }
    ]

    const headers = computed(() => {
      return [
        ...headers_main,
        {
          key: 'permissions_days',
          sortable: false,
          label: 'DÍAS PERMISOS',
          class: 'one-line bg-payroll'
        },
        {
          key: 'amount_permission',
          sortable: false,
          label: 'IMPORTE PERMISOS',
          class: 'one-line bg-payroll'
        },
        {
          key: 'amount_permission2',
          sortable: false,
          label: 'IMPORTE PERMISOS CGH',
          class: 'one-line bg-payroll'
        },
        ...allAdvanceTypes.value.map(type => {
          return {
            key: `advance_type_${type.id}`,
            sortable: false,
            label: type.name,
            class: 'one-line bg-payroll',
            formatter: (value: number) => {
              return formatAmount(value)
            }
          }
        }),
        {
          key: 'totalAdditionals',
          sortable: false,
          label: 'ADICIONALES',
          class: 'one-line bg-payroll'
        },
        {
          key: 'vacations_d',
          sortable: false,
          label: 'LIQUID./ VACAC. DEVENGADAS',
          class: 'one-line bg-payroll'
        },
        {
          key: 'vacations_t',
          sortable: false,
          label: 'LIQUID./ VACAC. TRUNCAS',
          class: 'one-line bg-payroll'
        },
        ...allBondTypes.value.map(type => {
          return {
            key: `bond_type_${type.id}`,
            sortable: false,
            label: type.name,
            class: 'one-line bg-payroll',
            formatter: (value: number) => {
              return formatAmount(value)
            }
          }
        }),
        {
          key: 'subsidies',
          sortable: false,
          label: 'SUBSIDIOS',
          class: 'one-line bg-payroll'
        },
        {
          key: 'absent_days',
          sortable: false,
          label: 'DÍAS INASISTENCIA',
          class: 'one-line bg-payroll'
        },
        {
          key: 'absent_amount',
          sortable: false,
          label: 'IMPORTE INASISTENCIA',
          class: 'one-line bg-payroll',
          formatter: (value: number) => {
            return formatAmount(value)
          }
        },
        {
          key: 'delay',
          sortable: false,
          label: 'TARD/INAS',
          class: 'one-line bg-payroll'
        },
        {
          key: 'sundayFactor',
          sortable: false,
          label: 'FACTOR DOMINICAL',
          class: 'one-line bg-payroll',
          formatter: (value: number) => {
            return formatAmount(value)
          }
        },
        {
          key: 'sundayPiecework',
          sortable: false,
          label: 'DOMINICAL DESTAJO',
          class: 'one-line bg-payroll',
          formatter: (value: number) => {
            return formatAmount(value)
          }
        },
        {
          key: 'sundayValue',
          sortable: false,
          label: 'VALOR DE UN DOMINGO',
          class: 'one-line bg-payroll'
        },
        {
          key: 'sundayJornale',
          sortable: false,
          label: 'DOMINICAL JORNAL',
          class: 'one-line bg-payroll'
        },
        {
          key: 'sundayFactorAmount',
          sortable: false,
          label: 'IMPORTE DSCTO DOMINICAL',
          class: 'one-line bg-payroll',
          formatter: (value: number) => {
            return formatAmount(value)
          }
        },
        {
          key: 'holiday_factor',
          sortable: false,
          label: 'FACTOR FERIADO',
          class: 'one-line bg-payroll'
        },
        {
          key: 'amount_holiday_discount',
          sortable: false,
          label: 'IMPORTE DSCTO FERIADO',
          class: 'one-line bg-payroll'
        },
        ...allDiscountTypes.value.map(type => {
          return {
            key: `discount_type_${type.id}`,
            sortable: false,
            label: type.name,
            class: 'one-line bg-payroll',
            formatter: (value: number) => {
              return formatAmount(value)
            }
          }
        }),
        {
          key: 'loan_total_discounted',
          sortable: false,
          label: 'PRESTAMO',
          class: 'one-line bg-payroll',
          formatter: (value: number) => {
            return formatAmount(value)
          }
        },
        /* {
          key: 'totalToPay',
          sortable: false,
          label: 'TOTAL A PAGAR',
          class: 'one-line bg-payroll',
          formatter: (value: number) => {
            return formatAmount(value)
          }
        }, */
        {
          key: 'adelantos',
          label: 'DESCUENTO POR ADELANTOS',
          bgColor: 'd7e4bd',
          sortable: false,
          class: 'one-line bg-payroll',
          formatter: (value: number) => {
            return formatAmount(value)
          }
        },
        {
          key: 'rem_basic',
          label: 'REM. BÁSICA',
          bgColor: 'd7e4bd',
          sortable: false,
          class: 'one-line bg-payroll',
          formatter: (value: number) => {
            return formatAmount(value)
          }
        },
        {
          key: 'discount_amount_total',
          label: 'DESCUENTOS',
          bgColor: 'd7e4bd',
          sortable: false,
          class: 'one-line bg-payroll',
          formatter: (value: number) => {
            return formatAmount(value)
          }
        },
        {
          key: 'total_to_pay_final',
          label: 'NETO A PAGAR',
          bgColor: 'd7e4bd',
          sortable: false,
          class: 'one-line bg-payroll',
          formatter: (value: number) => {
            return formatAmount(value)
          }
        },
        {
          key: 'rem_essalud',
          label: 'ESSALUD',
          bgColor: 'd7e4bd',
          sortable: false
        },
        {
          key: 'sctr_pension',
          label: 'SCTR PENSIÓN',
          bgColor: 'd7e4bd',
          sortable: false
        },
        {
          key: 'sctr_salud',
          label: 'SCTR SALUD',
          bgColor: 'd7e4bd',
          sortable: false
        },
        {
          key: 'vida_ley',
          label: 'VIDA LEY',
          bgColor: 'd7e4bd',
          sortable: false
        }
      ]
    })

    const headersExcel = computed(() => {
      const h = [
        ...headers.value
      ]
      h[3] = {
        key: 'employee.fullLastName',
        sortable: true,
        label: 'APELLIDOS',
        class: ''
      }
      const hFinal: {}[] = []
      h.forEach((header, index) => {
        if (index === 4) {
          const item = {
            key: 'employee.name',
            sortable: true,
            label: 'NOMBRES',
            class: ''
          }
          hFinal.push(item)
        }
        hFinal.push(header)
      })
      /* hFinal.push({
        key: 'rem_basic',
        label: 'REM. BÁSICA',
        bgColor: 'd7e4bd'
      })
      hFinal.push({
        key: 'discount_amount_total',
        label: 'DESCUENTOS',
        bgColor: 'd7e4bd'
      })
      hFinal.push({
        key: 'total_to_pay_final',
        label: 'NETO A PAGAR',
        bgColor: 'd7e4bd'
      }) */
      return hFinal
    })

    const payroll: Ref<PayrollGenerated[]> = ref([])

    const getDiscount = (discountTypeId: number, itemsDiscountControl: DiscountControl[]) => {
      return itemsDiscountControl.find(control => control.discount_type_id === discountTypeId)
    }

    const getDiscountValue = (discountTypeId: number, itemsDiscountControl: DiscountControl[]) => {
      const discountValid = getDiscount(discountTypeId, itemsDiscountControl)
      let total = 0
      if (discountValid) {
        total = discountValid.amount
      }
      return total
    }

    const getAllIncomeByItem = (item: PayrollGenerated) => {
      let total = item.total_fortnight +
              item.householdAllowance15 +
              item.refreshment +
              item.total_extra_25 +
              item.total_extra_35 +
              item.amount_permission +
              item.advanceControlWithAfpTotal +
              item.bondControlTotal +
              item.holidays_amount +
              item.additional -
              Number(item.delay)

      if (item.payed_days > 0 && item.days_piecework_fortnight > 0) {
        // no condiderar IMPORTE DOMINICAL, DOMINICAL DESATJO
      } else if (item.payed_days > 0 && item.days_piecework_fortnight <= 0) {
        if (item.has_permission_with_sunday_discount) {
          total -= item.sundayFactorAmount
        }
      } else {
        total += item.sundayPiecework
      }

      return total
    }

    const getAfpAmountByItem = (income: number, afp_percentage: number) => {
      return (afp_percentage * income) / 100
    }
    // sumar a la remuneración basica he 25 y he 35 - sumar adicionales listo!
    const getRemBasic = (item: PayrollGenerated) => {
      let feriados = 0
      const wc = Number(work_category)
      const isJornal = item.employee.assignment.work_type === WORK_TYPE_LABORER
      let total = 0
      // Calculos para la planilla de obreros
      if (wc === 1) { // condicion de obrero
        // Calculos para los empleados JORNALEROS
        if (isJornal) { // condición para jornalero
          // Formula que aplica: =+S5+T5+X5+AB5+AE5+AF5+AG5+AH5-AM5+AP5
          // Formula cambiada 19/11/2022 -> =+Q5+R5+V5+Z5+AC5+AD5+AE5+AF5+AG5+AH5+AI5-AM5-AP5
        if (item.employee.id === '72') {
            item.amount_of_sundays = 0
        }
         const sundayJornale = (item.amount_of_sundays - item.domingosconpermiso) * (Number(item.base_salary) / 30)
          total += item.total_fortnight + // Q : Quincena Total
                   item.householdAllowance15 + // R : Asignacion familiar 15
                   item.refreshment + // V : Refrigerio
                   item.amount_permission + // Z : Importe permiso
                   item.bondControlTotal + // AC5+AD5+AE5+AF5+AG5+AH5+AI5 Son los bonos, son dinamicos.
                   item.total_extra_25 + // horas extra 25%
                   item.total_extra_35 + // horas extra 35%
                   item.total_extra_double +
                    /* item.sundayPiecework */
                   sundayJornale - // 30-03-2023 anderson habilito este campo
                   item.sundayFactorAmount +
                   item.holidays_amount -
                   item.delay // AM : TARD/INAS
                   /* item.sundayFactorAmount // AP : Importe descuento dominical */
        } else {
          // Aca se calcula los obreros de categoria DESTAJO.
          // Formula dada: =+S16+T16+X16+Y16+AB16+AD16+AE16+AF16+AG16+AH16+AO16-AM16
          // Formula cambiada 19/11/2022 -> =+Q5+R5+V5+W5+Z5+AC5+AD5+AE5+AF5+AG5+AH5+AI5+AO5-AM5
          total += item.total_fortnight + // Q : Quincena total
                   item.householdAllowance15 + // R : Asignacion familiar 15
                   item.refreshment + // V : Refrigerio
                   item.holidays_amount + // W : Feriados
                   item.amount_permission + // Z : Importe permiso
                  /* item.total_extra_25 + // horas extra 25%
                   item.total_extra_35 + // horas extra 35% // verificar y agregar a formula 30-06-2023
                   item.total_extra_double + */
                   item.bondControlTotal + // AC5+AD5+AE5+AF5+AG5+AH5+AI5 Son los bonos, son dinamicos
                   item.sundayPiecework - // AO : Dominical Destajo
                   item.delay // AM : TARD/INAS
        }
      } else {
        const sundayJornale = (item.amount_of_sundays - item.domingosconpermiso) * (Number(item.base_salary) / 30)
        // Calculo de la planilla administrativa.
        // Formula dada para todos los empleados: =+Q4+R4+U4+V4+W4+Z4+AB4+AC4+AD4+AE4+AF4-AJ4-AM4
        // Nueva formula (16/11/2022/  =+Q3+R3+V3+Z3+AB3+AF3-AK3-AN3
        if (parseInt(year) < 2024 && parseInt(month) < 7) {
          if (item.employee.id === '89' || item.employee.id === '54') {
            feriados = sundayJornale
          } else {
            feriados = 0
          }
        } else {
            feriados = item.holidays_amount
        }
        total += item.total_fortnight + // Q : Quincena total
                 item.householdAllowance15 + // R : Asignacion familiar 15
                 item.refreshment + // V : Refrigerio
                 item.amount_permission + // Z : Importe permiso
                 item.totalAdditionals + // AB : Adicionales
                 item.total_extra_25 + // horas extra 25%
                 item.total_extra_35 + // horas extra 35%
                 item.total_extra_double +
                 item.bondControlTotal - // AC + AD + AE + AF Son los bonos, son dinamicos ahora son solo cuatro, pero otro dia pueden ser muchos mas o menos.
                 item.delay - // AK : TARD/INAS
                 item.sundayFactorAmount + // AN : Importe descuento dominical
                 sundayJornale +
                 feriados
      }
      return total
    }

    const getDiscountJudicialAmount = (item: PayrollGenerated) => {
      const discountJudicial = item.discount_control.find(discount => Number(discount.discount_type_id) === 1)
      if (discountJudicial) {
        if (discountJudicial.type === TYPE_AMOUNT) {
          return discountJudicial.amount
        }

        const income = getRemBasic(item)
        const afp = getAfpAmountByItem(income, Number(item.afp_total))
        const otherDiscount = item.discount_control.filter(discount => Number(discount.discount_type_id) !== 1 && discount.discountType.is_law).reduce((acc, discount) => acc + discount.amount, 0)

        return (income - afp - Number(item.rent) - otherDiscount) * (discountJudicial.amount / 100)
      }
      return 0
    }

    function calcularImporteTotalConSubsidio (permissions) {
      const importeTotal = permissions.reduce((total, permiso) => {
        if (permiso.permission.reason.has_subsidy) {
          return total + permiso.amount
        }
        return total
      }, 0)
     // console.log(importeTotal)
      return importeTotal
    }

    const getDiscountAmountTotal = (item: PayrollGenerated) => {
      const wc = Number(work_category)
      const isJornal = item.employee.assignment.work_type === WORK_TYPE_LABORER
      let total = 0
      let final = 0
      let importeTotalConSubsidio = 0
      let totalonp = 0

      // Calculos para la planilla de obreros
      if (wc === 1 && !isJornal) {
        // Suma de todos los tipos de descuentos
        const discountTotal = getDiscountJudicialAmount(item) + allDiscountTypes.value.filter(discountType => discountType.id > 1).reduce((total, discountType) => total + getDiscountValue(discountType.id, item.discount_control), 0)
        // La formula es diferente para los Obreros de tipo DESTAJO
        // Formula dada 23/11/2022 : =(+AV2*J2)+AP2+AQ2+AR2+AS2+AT2+AU2
        total += (Number(item.rem_basic) * Number(item.afp_total) / 100) + // (+AV*J)
                 // item.sundayFactorAmount + // AP  <-- Se pide sacar esta variable del calculo 29/11/2022
                 discountTotal + // AQ +AR +AS
                 item.rent + // AT
                 item.loan_total_discounted // AU
        final = total
      } else {
        // CALCULO DEL AL COLUMNA -> DESCUENTOS <-
        // FORMULA DADA (+AQ2*J2)+AM2+AL2+AP2+AN2+AO2
        total = (Number(item.rem_basic) * (Number(item.afp_total) / 100)) + // AQ -> REM. BASICA, J3 -> AFP/ONP
            item.loan_total_discounted // AP -> PRESTAMOS
        const discountTotal = getDiscountJudicialAmount(item) + allDiscountTypes.value.filter(discountType => discountType.id > 1).reduce((total, discountType) => total + getDiscountValue(discountType.id, item.discount_control), 0) // AM, AL, AN, AO -> COLUMNAS D DESCUENTAS, ESTAS COLUMNAS SON DINAMICAS, SERIA LA SUMA DE TODAS LAS COLUMNAS TANTAS ALLA, POR AHORA SOLO EXISEN SOLO ESTAS 4.
        final = total + discountTotal
      }

      importeTotalConSubsidio = calcularImporteTotalConSubsidio(item.permissions)
      totalonp = Number(item.afp_total)
      if (importeTotalConSubsidio === null) {
        importeTotalConSubsidio = 0
      }
      if (totalonp === null) {
        totalonp = 0
      }

      if (importeTotalConSubsidio > 0 && item?.employee?.insurance?.type_regime === TYPE_REGIME_ONP && totalonp > 0) {
        const totalsubsidio = importeTotalConSubsidio * (totalonp / 100)
        return Number(final) -
             Number(totalsubsidio) // esta formula se agrego el 20/05/2023 para descontar el importe de ONP
      } else {
        return final
      }
    }

    const getAfpTotal = (item: PayrollGenerated) => { // aca se debe aplicar la funcion que modifique el afp con
      if (item.afp_tope && item.salary_total && item.afp_insurance && item.afp_subtotal) {
        if (item.afp_tope > 0 && item.salary_total > item.afp_tope) {
          const valor1 = (item.salary_total + item.bondControlTotal) * (item.afp_subtotal / 100)
          const valor2 = item.afp_insurance * (item.afp_tope / 100)
          const sumavalores = valor2 + valor1
          return (sumavalores / (item.salary_total + item.bondControlTotal) * 100).toFixed(3)
        } else {
          return item.afp_total
        }
      }
      return item.afp_total // Manejo del caso en que alguna propiedad sea nula
    }

    const getTotalToPayFinal = (item: PayrollGenerated) => {
      // CALCULO DE LA COLUMNA -> NETO A PAGAR <-
      // FORMULA DADA =+AQ24-AR24
      return Number(item.rem_basic) - // AQ --> REM. BASICA
             Number(item.discount_amount_total) // AR --> DESCUENTOS
    }

    const setFinalValues = (item: PayrollGenerated) => {
      item.afp_total = getAfpTotal(item)
      if (item.afp_tope && item.salary_total && item.afp_insurance && item.afp_subtotal) {
        item.afp_total2 = item.afp_insurance + item.afp_subtotal
      } else {
        item.afp_total2 = item.afp_total
      }
      item.rem_basic = getRemBasic(item)
      item.discount_amount_total = getDiscountAmountTotal(item) + item.adelantos
      item.total_to_pay_final = getTotalToPayFinal(item)
      item.rem_essalud = 0.09 * item.rem_basic
    }

    const setDiscountAmount = (item: PayrollGenerated, discountTypeId: number, value: number|string) => {
      const amount = Number(value) || 0
      if (!item.discount_control) {
        item.discount_control = []
      }
      const existing = getDiscount(discountTypeId, item.discount_control)
      if (existing) {
        existing.amount = amount
      } else {
        const discountType = allDiscountTypes.value.find(t => Number(t.id) === Number(discountTypeId))
        item.discount_control.push({
          id: 0,
          employee_id: Number(item.employee.id),
          employee: item.employee as any,
          discount_type_id: Number(discountTypeId),
          discountType: discountType || ({ id: discountTypeId } as DiscountTypeModel),
          amount,
          amount_text: '',
          type: TYPE_AMOUNT,
          date: '',
          observations: '',
          frequency: 0,
          frequency_text: '',
          created_at: '',
          updated_at: '',
          deleted_at: ''
        })
      }
      setFinalValues(item)
    }

    const onRefreshmentSaved = (payload: { snackDays: number; refreshment: number }) => {
      if (refreshmentItem.value) {
        refreshmentItem.value.snackDays = payload.snackDays
        refreshmentItem.value.refreshment = payload.refreshment
        setFinalValues(refreshmentItem.value)
      }
    }

    const updateAmountPermission = (item: PayrollGenerated) => {
      item.amount_permission = item.permissions.reduce((total, permission) => total + permission.amount, 0)
      setFinalValues(item)
    }

    const generatePayroll = async () => {
      loading.value = true
      const workCategory = work_category ? String(work_category) : null
      const result = await PayrollService.generate(Number(year), Number(month), Number(fortnight), workCategory)
      payroll.value = result.map(item => {
        item.rem_basic = 0
        item.discount_amount_total = 0
        item.total_to_pay_final = 0
        setFinalValues(item)
        // Setear valores anteriores de los campos editables
        // Buscar el registro viejo pr empleado/
        const oldEmployeeData = oldPayrollData.value.find(old => Number(old.employee.id) === Number(item.employee.id))
        if (oldEmployeeData) {
          item.amount_permission = oldEmployeeData.amount_permission
          item.totalAdditionals = oldEmployeeData.totalAdditionals
          item.subsidies = oldEmployeeData.subsidies
          item.delay = oldEmployeeData.delay
          // item.total_amount_hours_normal = oldEmployeeData.total_amount_hours_normal
          item.total_amount_hours_extra_25 = oldEmployeeData.total_amount_hours_extra_25
          item.total_amount_hours_extra_35 = oldEmployeeData.total_amount_hours_extra_35
          item.holiday_factor = oldEmployeeData.holiday_factor
          item.amount_holiday_discount = oldEmployeeData.amount_holiday_discount
         // item.total_extra_double = oldEmployeeData.total_extra_double
          item.snackDays = oldEmployeeData.snackDays
          item.refreshment = oldEmployeeData.refreshment
          const oldRent = oldEmployeeData.discount_control.find(d => Number(d.discount_type_id) === DISCOUNT_TYPE_RENT_5TH)
          if (oldRent) {
            const currentRent = item.discount_control.find(d => Number(d.discount_type_id) === DISCOUNT_TYPE_RENT_5TH)
            if (currentRent) {
              currentRent.amount = oldRent.amount
            } else {
              item.discount_control.push({ ...oldRent })
            }
          }
          setFinalValues(item)
        }
        return {
          ...item
        }
      })
      loading.value = false
    }
    const totalToPay = computed(() => {
      return payroll.value.reduce((acc, payroll) => acc + Number(payroll?.total_to_pay_final), 0)
    })
    const getAmountToPay = (item: PayrollGenerated) => {
      let total = 0
      const income = getAllIncomeByItem(item)

      total = income

      const afpAmount = getAfpAmountByItem(income, Number(item.afp_total))

      if (item.employee.insurance.type_regime === TYPE_REGIME_AFP) {
        total += item.subsidies
      }

      total += item.advanceControlWithOutAfpTotal
      total -= afpAmount

      const discount = item.rent + item.loan_total_discounted

      total -= discount

      if (item.employee.insurance.type_regime === TYPE_REGIME_ONP) {
        total += item.subsidies
      }

      item.discount_control.forEach(discount => {
        if (Number(discount.discount_type_id) !== 1) {
          total -= discount.amount
        }
        if (actionForm.value === 'update') {
          total -= discount.amount
        }
      })
      if (actionForm.value === 'save') {
        total -= getDiscountJudicialAmount(item)
      }

      return total
    }

    const itemsExcel = computed(() => {
      let i = 1
      return payroll.value.map(p => {
        let permissions_days = `Días: ${p.total_permission_days}`
        let amount_permission = ''
        p.permissions.forEach(permission_item => {
          permissions_days += ','
          permissions_days += `${permission_item.permission.reason.abbreviated}: ${permission_item.days}`

          amount_permission += `${permission_item.permission.reason.abbreviated}: ${permission_item.amount}\n`
        })

        const amount_permission2 = `${p.amount_permission}`

        const item = {
          ...p,
          index: i++,
          payed_days_total: p.payed_days + p.days_piecework_fortnight,
          employee: {
            ...p.employee,
            assignment: {
              ...p.employee.assignment,
              work_type: getTextWorkType(p.employee.assignment.work_type),
              type_of_contract: getTextTypeOfContract(p.employee.assignment.type_of_contract)
            }
          },
          type_regime: p.employee.insurance.type_regime === 2 ? p.employee.insurance.afp.name : 'ONP',
          afp_total: p.afp_total ? `${p.afp_total} %` : '',
          totalToPay: p.totalToPay,
          sundayValue: formatAmount(Number(p.base_salary) / 30),
          sundayJornale: formatAmount(Number(p.amount_of_sundays - p.domingosconpermiso) * (Number(p.base_salary) / 30)),
          permissions_days: permissions_days,
          amount_permission: amount_permission,
          amount_permission2: amount_permission2
        }

        allAdvanceTypes.value.forEach(_t => {
          const key = `advance_type_${_t.id}`
          const advanceControls = item.advance_control.filter(t => t.advance_type_id === _t.id)
          // @ts-ignore
          item[key] = advanceControls.length > 0
            ? advanceControls.reduce((acc, type) => acc + type.amount, 0)
            : 0
        })
        allBondTypes.value.forEach(_t => {
          const key = `bond_type_${_t.id}`
          const bondControls = p.bond_control.filter(t => t.bond_type_id === _t.id)
          // @ts-ignore
          item[key] = bondControls.length > 0
            ? bondControls.reduce((acc, type) => acc + type.amount, 0)
            : 0
        })
        allDiscountTypes.value.forEach(_t => {
          if (Number(_t.id) !== 1) {
            const key = `discount_type_${_t.id}`
            const t = getDiscountValue(_t.id, p.discount_control) || 0
            // @ts-ignore
            item[key] = t
          } else {
            const key = `discount_type_${_t.id}`
            const t = getDiscountJudicialAmount(p) || 0
            // @ts-ignore
            item[key] = t
          }
        })
        return item
      })
    })

    const refresh = () => {
      oldPayrollData.value = [...payroll.value]
      generatePayroll()
    }

    const createPayroll = async () => {
      loading.value = true
      const wc = Number(work_category)
      const payrollFormInput: PayrollInput = {
        month: Number(month),
        year: Number(year),
        fortnight: Number(fortnight),
        work_category: wc > 0 ? wc : null,
        total_to_pay: Number(totalToPay.value.toFixed(2)),
        amount_of_sundays: Number(payroll.value[0].amount_of_sundays),
        items: payroll.value.map(item => {
          return {
            work_type: item.employee.assignment.work_type,
            type_regime: item.employee.insurance.type_regime,
            afp_total: Number(item.afp_total),
            total_to_pay: item?.total_to_pay_final || 0,
            employee_id: item.employee.id,
            base_salary: Number(item.base_salary),
            family_allowance: Number(item.employee.finance.family_allowance),
            household_allowance_15: Number(item.householdAllowance15),
            rent: item.rent,
            loan_total_discounted: item.loan_total_discounted,
            salary_total: item.salary_total,
            month_days: item.month_days,
            payed_days: item.payed_days,
            subsidies: item.subsidies,
            days_piecework_fortnight: item.days_piecework_fortnight,
            basic_fortnight: item.basic_fortnight,
            basic_piecework_fortnight: item.basic_piecework_fortnight,
            total_extra_25: item.total_extra_25,
            total_extra_35: item.total_extra_35,
            rem_essalud: item.rem_essalud,
            sctr_pension: item.sctr_pension,
            sctr_salud: item.sctr_salud,
            adelantos: item.adelantos,
            ajenos: item.ajenos,
            amount_of_sundays: item.amount_of_sundays,
            vida_ley: item.vida_ley,
            vacations_d: item.vacations_d,
            vacations_t: item.vacations_t,
            snack_days: item.snackDays,
            refreshment: item.refreshment,
            loan_total: item.loan_total_discounted,
            permissions_days: item.total_permission_days,
            amount_permission: item.amount_permission,
            total_additionals: item.totalAdditionals,
            absent_days: item.absent_days,
            domingosconpermiso: item.domingosconpermiso,
            absent_amount: item.absent_amount,
            sunday_factor: item.sundayFactor,
            sunday_piecework: item.sundayPiecework,
            sunday_factor_amount: item.sundayFactorAmount,
            advance_control_with_afp_total: item.advanceControlWithAfpTotal,
            advance_control_with_out_afp_total: item.advanceControlWithOutAfpTotal,
            bond_control_total: item.bondControlTotal,
            has_permission_with_subsidy: item.has_permission_with_subsidy,
            has_permission_with_sunday_discount: item.has_permission_with_sunday_discount,
            holidays: item.holidays,
            holidays_amount: item.holidays_amount,
            delay: item.delay,
            apply_holidays_amount: item.apply_holidays_amount,
            total_amount_hours_normal: item.total_amount_hours_normal,
            total_amount_hours_extra_25: item.total_amount_hours_extra_25,
            total_amount_hours_extra_35: item.total_amount_hours_extra_35,
            holiday_factor: item.holiday_factor,
            amount_holiday_discount: item.amount_holiday_discount,
            total_extra_double: item.total_extra_double,
            permissions: item.permissions.map(permission => {
              return {
                reason_permission_id: permission.permission.reason_id,
                days: permission.days,
                amount: permission.amount
              }
            }),
            bond_types: allBondTypes.value.map(t => {
              return {
                bond_type_id: t.id,
                amount: item.bond_control.filter(type => Number(type.bond_type_id) === Number(t.id)).reduce((acc, _type) => acc + _type.amount, 0)
              }
            }),
            advance_types: allAdvanceTypes.value.map(t => {
              return {
                advance_type_id: t.id,
                amount: item.advance_control.filter(type => Number(type.advance_type_id) === Number(t.id)).reduce((acc, _type) => acc + _type.amount, 0)
              }
            }),
            discount_types: allDiscountTypes.value.map(t => {
              const d = getDiscount(t.id, item.discount_control)
              return {
                discount_type_id: t.id,
                amount: d?.amount ?? 0,
                type: d?.type ?? 0
              }
            })
          }
        }),
        advances: allAdvanceTypes.value.map(t => {
          return {
            advance_type_id: t.id
          }
        }),
        bonds: allBondTypes.value.map(t => {
          return {
            bond_type_id: t.id
          }
        }),
        discounts: allDiscountTypes.value.map(t => {
          return {
            discount_type_id: t.id
          }
        })
      }
      try {
        if (actionForm.value === 'save' && !idPayrollEdit.value) {
          await PayrollService.create(payrollFormInput)
        } else {
          await PayrollService.update(Number(idPayrollEdit.value), payrollFormInput)
        }
        alerts.success()
        router.push({
          name: 'work-sheets'
        })
      } catch (e) {
        alerts.error()
      }
      loading.value = false
    }

    const setPayroll = (payroll_old: BiweeklyPayroll) => {
      loading.value = true
      actionForm.value = 'update'
      idPayrollEdit.value = payroll_old.id
      allDiscountTypes.value = payroll_old.discountTypes.map(t => {
        return {
          ...t.discountType
        }
      })
      allAdvanceTypes.value = payroll_old.advanceTypes.map(t => {
        return {
          ...t.advanceType
        }
      })
      allBondTypes.value = payroll_old.bondTypes.map(t => {
        return {
          ...t.bondType
        }
      })
      payroll.value = payroll_old.payrollItems.map(item => {
        const domingosnuevos = item.amount_of_sundays > 0 ? item.amount_of_sundays : payroll_old.amount_of_sundays
        const payrollItem: PayrollGenerated = {
          employee: item.employee,
          salary_total: item.salary_total,
          base_salary: item.base_salary,
          payed_days: item.payed_days,
          ajenos: item.ajenos,
          list_task: [],
          total_extra_25: item.total_extra_25,
          total_extra_35: item.total_extra_35,
          rem_essalud: item.rem_essalud,
          sctr_pension: item.sctr_pension,
          sctr_salud: item.sctr_salud,
          vida_ley: item.vida_ley,
          vacations_d: item.vacations_d,
          vacations_t: item.vacations_t,
          month_days: item.month_days,
          basic_fortnight: item.basic_fortnight,
          afp_total: item.afp_total,
          afp_total2: item.afp_total,
          afp_insurance: item.afp_insurance,
          afp_tope: item.afp_tope,
          afp_subtotal: item.afp_subtotal,
          householdAllowance15: item.household_allowance_15,
          absent_amount: item.absent_amount,
          absent_days: item.absent_days,
          domingosconpermiso: item.domingosconpermiso,
          sundayFactor: item.sunday_factor,
          additional: 0,
          adelantos: item.adelantos,
          additionalTotal: item.total_additionals,
          snackDays: item.snack_days,
          refreshment: item.refreshment,
          loan_total_discounted: item.loan_total_discounted,
          loan_total: item.loan_total,
          rent: item.rent,
          subsidies: item.subsidies,
          totalToPay: item.total_to_pay,
          days_piecework_fortnight: item.days_piecework_fortnight,
          basic_piecework_fortnight: item.basic_piecework_fortnight,
          total_permission_days: item.permissions_days,
          amount_permission: item.amount_permission,
          sundayFactorAmount: item.sunday_factor_amount,
          sundayPiecework: item.sunday_piecework,
          totalAdditionals: item.total_additionals,
          total_fortnight: item.basic_piecework_fortnight + item.basic_fortnight,
          has_permission_with_subsidy: item.has_permission_with_subsidy,
          has_permission_with_sunday_discount: item.has_permission_with_sunday_discount,
          advanceControlWithAfpTotal: item.advance_control_with_afp_total,
          advanceControlWithOutAfpTotal: item.advance_control_with_out_afp_total,
          bondControlTotal: item.bond_control_total,
          holidays: item.holidays,
          holidays_amount: item.holidays_amount,
          delay: item.delay,
          apply_holidays_amount: item.apply_holidays_amount,
          total_amount_hours_normal: item.total_amount_hours_normal,
          total_amount_hours_extra_25: item.total_amount_hours_extra_25,
          total_amount_hours_extra_35: item.total_amount_hours_extra_35,
          holiday_factor: item.holiday_factor,
          amount_holiday_discount: item.amount_holiday_discount,
          total_extra_double: item.total_extra_double,
          amount_of_sundays: domingosnuevos,
          permissions: item.permissions.map(permission => {
            return {
              days: permission.days,
              amount: permission.amount,
              permission: {
                id: permission.id,
                employee_id: item.employee_id,
                employee: item.employee,
                reason_id: permission.reason_permission_id,
                reason: permission.reasonPermission,
                date_start: '',
                date_end: '',
                observations: '',
                created_at: new Date(),
                updated_at: new Date(),
                deleted_at: new Date()
              }
            }
          }),
          bond_control: item.bondTypes.map(t => {
            return {
              id: t.id,
              employee_id: item.employee.id,
              employee: item.employee,
              amount: t.amount,
              observations: '',
              bond_type_id: t.bond_type_id,
              bondType: t.bondType,
              headquarter_id: item.employee.assignment.headquarter_id,
              area_id: item.employee.assignment.area_id,
              sub_area_id: item.employee.assignment.sub_area_id,
              year: 0,
              month: 0,
              fortnight: 1,
              abstents_first_week: 0,
              abstents_second_week: 0,
              loaded_massive: false,
              is_active: true,
              status_text: '',
              created_at: '',
              updated_at: null,
              deleted_at: null
            }
          }),
          advance_control: item.advanceTypes.map(t => {
            return {
              id: t.id,
              employee_id: item.employee.id,
              employee: item.employee,
              advance_type_id: t.advance_type_id,
              advanceType: t.advanceType,
              register_date: '',
              discount_date: '',
              amount: t.amount,
              observations: '',
              created_at: '',
              updated_at: '',
              deleted_at: ''
            }
          }),
          discount_control: item.discountTypes.map(t => {
            return {
              id: t.id,
              employee_id: item.employee.id,
              employee: item.employee,
              discount_type_id: t.discount_type_id,
              discountType: t.discountType,
              amount: t.amount,
              amount_text: '',
              type: t.type,
              date: '',
              observations: '',
              frequency: 0,
              frequency_text: '',
              created_at: '',
              updated_at: '',
              deleted_at: ''
            }
          })
        }
        payrollItem.rem_basic = getRemBasic(payrollItem)
        payrollItem.discount_amount_total = getDiscountAmountTotal(payrollItem)
        payrollItem.total_to_pay_final = getTotalToPayFinal(payrollItem)
        return payrollItem
      })
      loading.value = false
    }

    onMounted(async () => {
      const wc = Number(work_category) > 0 ? Number(work_category) : null
      const existPayroll = await PayrollService.exist(Number(year), Number(month), Number(fortnight), wc)
      if (existPayroll.exist) {
        setPayroll(existPayroll.payroll)
      } else {
        await getAllParameters()
        generatePayroll()
      }
    })

    return {
      loading,
      breadcrumbs,
      title,
      description,
      headers,
      payroll,
      allReasonPermission,
      allBondTypes,
      allAdvanceTypes,
      allDiscountTypes,
      TYPE_PERCENTAGE,
      TYPE_AMOUNT,
      getDiscountValue,
      getTextWorkType,
      totalToPay,
      itemsExcel,
      refresh,
      headersExcel,
      getAmountToPay,
      getDiscountJudicialAmount,
      TYPE_REGIME_NOT_APPLY,
      TYPE_REGIME_ONP,
      TYPE_REGIME_AFP,
      createPayroll,
      actionForm,
      filter,
      getRemBasic,
      getDiscountAmountTotal,
      setFinalValues,
      getTotalToPayFinal,
      updateAmountPermission,
      DISCOUNT_TYPE_RENT_5TH,
      setDiscountAmount,
      showRefreshmentModal,
      refreshmentEmployeeId,
      refreshmentEmployeeName,
      payrollYear,
      payrollMonth,
      payrollFortnight,
      openRefreshmentModal,
      closeRefreshmentModal,
      onRefreshmentSaved
    }
  }
})
